<div *ngIf="showHeader" class="mc-publication-progress-bar-header">
  <b>Publication Progress</b>

  <span class="mc-fill-remaining-flex-space"></span>

  <span [ngClass]="textColorClassForPublicationState">
    {{ statusDisplayText }}
    <ng-container *ngIf="publication.IsStopped">
      after {{ publication.RanFor | mcDuration }}
    </ng-container>
  </span>
</div>

<mat-progress-bar mode="determinate" [color]="colorForPublicationState" [value]="publication.Progress"></mat-progress-bar>

<div *ngIf="showFooter" class="mc-publication-progress-bar-footer">
  <span class="mc-text-muted">
    {{ errorCount | number: '1.0-0' }} {{ errorCount === 1 ? 'Error' : 'Errors' }},
    {{ warningCount | number: '1.0-0' }} {{ warningCount === 1 ? 'Warning' : 'Warnings' }}
  </span>
  <span class="mc-fill-remaining-flex-space"></span>

  <span class="mc-text-muted">{{ publication.Progress | number: '1.0-0' }}%</span>
</div>
